module.exports = __webpack_public_path__ + "assets/img/bg2-9246860c.jpg";